import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-footer',
    templateUrl: './modal-footer.component.html',
})
export class ModalFooterComponent {
    @Input() nextOperationBtnName: string | undefined;
    @Input() modalCloseBtnName: string | undefined;

    @Input({ required: true }) isFormInvalid = true;
    @Input() isPrimaryButtonClicked = false;

    @Output() primaryButtonClicked = new EventEmitter();
    @Output() modalClosed = new EventEmitter();

    constructor(public activeModal: NgbActiveModal) {}

    onSave() {
        this.primaryButtonClicked.emit();
    }

    onClose() {
        this.activeModal.close();
        this.modalClosed.emit();
    }
}
